export function base64ToPdfBlob(base64: string): Blob | null {
  if (!base64 || typeof base64 !== 'string') return null;
  const cleaned = base64.includes(',') ? base64.split(',')[1] : base64;
  try {
    const binaryString = typeof atob === 'function' ? atob(cleaned) : Buffer.from(cleaned, 'base64').toString('binary');
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return new Blob([bytes], { type: 'application/pdf' });
  } catch (e) {
    console.warn('Failed to convert base64 to PDF blob', e);
    return null;
  }
}

